import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import LineChart from "./components/Charts/Line/LineChart";
import BarChart from "./components/Charts/Bar/BarChart";
import HorizontalBarChart from "./components/Charts/HorizontalBar/HorizontalBarChart";
import DoughnutChart from "./components/Charts/Doughnut/DoughnutChart";
import PieChart from "./components/Charts/Pie/PieChart";
import { DashboardService } from "./services/DashboardService";
import { Http } from "@status/codes";
import { ChartRenderData } from "./models/ChartRenderData";
import { ChartData } from "./models/ChartData";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  CHART_TYPES,
  DASHBOARD_LABELS,
  DASHBOARD_MESSAGES,
  DOWNLOAD_MODAL_TEXT,
  DOWNLOAD_MODAL_TITLE,
  FILTERED_DASHBOARD_TAGS,
  FILTERS_LIST,
  FILTER_CONSTANTS,
  FILTER_STATE_ACTIVATION,
  FORMS_HEADERS,
  INITIAL_FILTER,
  MAIN_FILTER,
  LACK_OF_OPTIONS,
  ORDER_HEADERS,
  SERVICE_HEADERS,
  SESSION_HEADERS,
  TAG_FILTER_NAMES,
  UNRATED_OR_NOAPPLY,
  USERS_HEADERS,
  PATIENT,
  ACTIVE,
  ATTRIBUTES_OF_DASHBOARD_FILTER,
  ATTRIBUTES_OF_DASHBOARD_FILTER_OBJECT,
  DEFAULT_GROUP_BY_TYPE_INDEX,
  GROUP_BY_FIELDS_SERVICE,
  GROUP_BY_FIELDS_MEDICAL_ORDERS,
  GROUP_BY_FIELDS_FORMS,
  GROUP_BY_FIELDS_SESSIONS,
  USERS,
  MAIN_FILTER_FOR_INNER_GROUPING,
  INNER_GROUPERS,
  NO_GROUP_LABEL,
  SERVICE_TYPE_TRANSLATE,
  COLUMN_FILTER_UPDATE,
  TASKS_HEADERS,
  COLLECTIONS,
  GROUP_BY_FIELDS_TASK,
  DATE_FORMAT,
  DAY_IN_MS,
  ORDER_GEN_UTILS,
  GROUP_BY_FIELDS_BY_COLLECTION,
  DOWNLOAD_MODAL_TEXT_FULL,
  DOWNLOAD_FILE_GENERATED_TEXT,
  DOWNLOAD_FILE_GENERATED_TITLE,
  DOWNLOAD_AND_UPDATE_TITLE,
  DOWNLOAD_AND_UPDATE_TEXT,
  DOWNLOAD_AND_UPDATE_BTN,
  DOWNLOAD_BTN,
  CANCEL_BTN,
  DASBOARD_CURRENT_FILTER,
  ORDER_UPDATE_STATES,
  UPDATE_ORDER_CONTANTS,
  INIT_PAGE,
  TABLE_COLUMNS_GROUP_FILTER,
  ACTIONS_VALUE
} from "./constants/AdminDashboardConstants";
import { TableField } from "./models/TableField";
import { SERVICE_STATE_COLORS } from "@/modules/Services/constants/ServicesConstants";
import { TableHeader } from "./models/TableHeader";
import Sortable from "sortablejs";
import { Utils } from "@/shared/utils/utils";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import { DashboardFilter } from "./models/DashboardFilter";
import { OrderService } from "@/modules/Orders/services/OrderService";
import NewActionCard from "./components/NewActionCard/NewActionCard.vue";
import { ActionParameters } from "./models/ActionParameters";
import AddTask from "@/modules/Tasks/components/AddTask/AddTask.vue";
import { RolesService } from "@/modules/Roles/services/RolesService";
import { InfoGroupService } from "@/modules/InfoGroup/services/InfoGroupService";
import { RoleInfo } from "@/modules/Roles/models/RoleInfo";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";
import {
  DEPENDENCIES_ACCESS,
  DEPENDENCIES_MESSAGES
} from "@/modules/Dependencies/constants/DependenciesConstants";
import {
  INFO_GROUPS_ACCESS,
  INFO_GROUP_CONSTANTS
} from "@/modules/InfoGroup/constants/InfoGroupConstants";
import {
  USER_TEMPLATES_ACCESS,
  USER_TEMP_CONSTANTS
} from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { USER_CONSTANTS } from "@/modules/User/constants/UserConstants";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import { HeaderInfoGroup } from "@/modules/InfoGroup/models/HeaderInfoGroup";
import {
  ACTION_EVENT,
  ACTION_MESSAGE,
  ACTION_TASK_CONSTANTS,
  COMPARISON_FILTERS,
  DASHBOARD_ACCESS,
  DOCUMENT_STATES
} from "./constants/ActionConstants";
import { ActionId } from "./models/ActionId";
import { MedicalOrderFieldsMap } from "@/modules/MedicalOrder/models/MedicalOrderFieldsMap";
import { OrderTemplate } from "@/modules/Orders/models/OrderTemplate";
import UserFieldsDialog from "./components/UserFieldsDialog/UserFieldsDialog.vue";
import MedicalOrderFieldsDialog from "./components/MedicalOrderFieldsDialog/MedicalOrderFieldsDialog.vue";
import { FormSchema } from "@/shared/models/FormSchema";
import {
  ORDER_ACCESS,
  ORDER_CONSTANTS,
  ORDER_STATES
} from "@/modules/Orders/constants/OrderConstants";
import { ListService } from "@/modules/List/services/ListService";
import { OrderListDataView } from "@/modules/Orders/models/OrderListDataView";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import TooltipButton from "@/shared/components/TooltipButton/TooltipButton.vue";
import Filesaver from "file-saver";
import {
  EXCEL_CONSTANTS,
  GENERATED_BY_RULE_ORDER,
  KEYTYPE_CONSTANTS,
  NAME_FINDERS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Vuetify from "vuetify";
import { FilterTypeListChart } from "./models/FilterTypeListChart";
import NotificationModal from "@/modules/Notification/components/NotificationModal/NotificationModal.vue";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { List, ObjList } from "@/shared/components/GenericSearchBar/model/List";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { DependenciesService } from "@/modules/Dependencies/services/DependenciesService";
import { TreeChildren } from "./models/TreeChilden";
import { FullSchema } from "@/shared/models/FullSchema";
import { Field } from "@/modules/FormTemplate/models/Field";
import { SessionTemplateService } from "@/modules/SessionTemplate/services/SessionTemplateService";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import MedicalOrder from "@/modules/MedicalOrder/MedicalOrder.vue";
import LoadOrders from "@/modules/MedicalOrder/components/LoadOrders/LoadOrders.vue";
import { MAX_WIDTH_MODALS } from "@/modules/Profile/constants/ProfileConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import lodash from "lodash";
import { ColumnStatus } from "./models/ColumnStatus";
import { GROUPER_KEYS } from "../constants/DashboardConstants";
import { AxiosError } from "axios";
import { ROLES_ACCESS } from "@/modules/Roles/constants/RoleConstants";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { SESSION_TEMPLATES_ACCESS } from "@/modules/SessionTemplate/constants/SessionTemplateConstants";
import { DATA_TYPE_CONSULT } from "@/shared/components/GenericSearchBar/constants/GenericSearchConstants";
import { KeyExists } from "./models/KeyExists";
import moment from "moment";
import TaskActions from "./components/TaskActions/TaskActions.vue";
import ReportAddTask from "@/shared/components/ReportAddTask/ReportAddTask.vue";
import MedicalOrderDetail from "@/modules/MedicalOrder/components/MedicalOrderDetail/MedicalOrderDetail.vue";
import { ReportAddTaskData } from "@/shared/components/ReportAddTask/models/ReportAddTaskData.model";
import { mapGetters } from "vuex";
import store from "@/store";
import { Dependency } from "@/modules/Dependencies/models/Dependency";
import { ActionError } from "./models/ActionTask";
import { MedicalOrderPreviewEventTimelineModel } from "@/modules/MedicalOrder/models/MedicalOrderPreviewEventTimelineModel";
import { MedicalOrderService } from "@/modules/MedicalOrder/services/MedicalOrderService";
import { PaginationData } from "./models/PaginationData";
import ChangeStateAction from "./components/ChangeStateAction/ChangeStateAction.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";

Vue.use(Vuetify);
@Component({
  name: "AdminDashboard",
  components: {
    LineChart,
    BarChart,
    HorizontalBarChart,
    DoughnutChart,
    PieChart,
    NewActionCard,
    EmptyState,
    AddTask,
    NotificationModal,
    UserFieldsDialog,
    MedicalOrderFieldsDialog,
    TooltipButton,
    ModalTemplate,
    GenericSearchBar,
    MedicalOrder,
    LoadOrders,
    TaskActions,
    ReportAddTask,
    MedicalOrderDetail,
    ChangeStateAction
  },
  directives: {
    "sortable-table": {
      inserted: (el, binding) => {
        Utils.handleTableRowClass(el);
        Sortable.create(
          el.querySelector("tr") as HTMLTableRowElement,
          binding.value ? { ...binding.value, handle: ".sortHandle" } : {}
        );
      }
    }
  },
  computed: {
    ...mapGetters({
      dashboardSearchName: "getDashBoardNameSearch"
    })
  }
})
export default class AdminDashboard extends Vue {
  @Inject() listService!: ListService;
  @Inject() dashboardService!: DashboardService;
  @Inject() orderService!: OrderService;
  @Inject() rolesService!: RolesService;
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() dependenciesService!: DependenciesService;
  @Inject() sessionTemplateService!: SessionTemplateService;
  @Inject() medicalOrderService!: MedicalOrderService;

  chartData: ChartRenderData = {
    labels: [],
    datasets: [
      {
        data: []
      }
    ]
  };

  LOADING = DASHBOARD_LABELS.LOADING;
  BAR = CHART_TYPES[0];
  HORIZONTAL_BAR = CHART_TYPES[1];
  PIE = CHART_TYPES[2];
  DOUGHNUT = CHART_TYPES[3];
  LINE = CHART_TYPES[4];
  GROUP_BY = DASHBOARD_LABELS.GROUP_BY;
  NO_SECTIONS = DASHBOARD_LABELS.NO_SECTIONS;
  NO_GROUPS = DASHBOARD_LABELS.NO_GROUPS;
  NO_SERVICES = DASHBOARD_LABELS.NO_SERVICES;
  NO_ROLE = DASHBOARD_LABELS.NO_ROLE;

  INVALID = DASHBOARD_LABELS.INVALID;
  RESULTS = DASHBOARD_LABELS.RESULTS;
  COLUMNS_MENU = DASHBOARD_LABELS.COLUMNS_MENU;
  ACTIONS_MENU = DASHBOARD_LABELS.ACTIONS_MENU;
  EXPORT_EXCEL = DASHBOARD_LABELS.EXPORT_EXCEL;
  DOWNLOAD_MODAL_TITLE = DOWNLOAD_MODAL_TITLE;
  DOWNLOAD_MODAL_TEXT = DOWNLOAD_MODAL_TEXT;
  BACK_LEVEL_FILTER = DASHBOARD_LABELS.BACK_LEVEL_FILTER;
  GROUP_BY_DEEPLEVEL = DASHBOARD_LABELS.GROUP_BY_DEEPLEVEL;
  UPLOAD_MULTIPLE_ORDERS = DASHBOARD_LABELS.UPLOAD_MULTIPLE_ORDERS;
  MAX_WIDTH = MAX_WIDTH_MODALS;
  NO_DEPENDENCY_LABEl = ACTION_TASK_CONSTANTS.LABELS.NO_DEPENDENCIES;
  SEARCH_ADMIN_DASHBOARD_KEY = NAME_FINDERS.ADMIN_DASHBOARD;
  GENERATED_BY_RULE_ORDER = GENERATED_BY_RULE_ORDER;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  DOWNLOAD_AND_UPDATE_TITLE = DOWNLOAD_AND_UPDATE_TITLE;
  DOWNLOAD_AND_UPDATE_TEXT = DOWNLOAD_AND_UPDATE_TEXT;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  DOWNLOAD_AND_UPDATE_BTN = DOWNLOAD_AND_UPDATE_BTN;
  DOWNLOAD_BTN = DOWNLOAD_BTN;
  CANCEL_BTN = CANCEL_BTN;

  chartTypes = CHART_TYPES;
  groupByArray: { key: string; name: string; deepLevel: any }[] = [];
  groupByKeys: string[] = [];
  allChartData: ChartData = {};
  allTableData: TableField[] = [];
  groupByTypeIndex = DEFAULT_GROUP_BY_TYPE_INDEX;
  groupByTypeDeepIndex = 0;
  currentChartType = "pie";
  currentMainFilter = "";
  currentTableData: TableField[] = [];
  selectedTableData: TableField[] = [];
  userIdArray: ActionId[] = [];
  selectedUserRelated: string[] = [];
  countSelectUsers = 0;
  currentChartItem = "";
  convertField = "";
  sortBy = "";
  sortDesc = "";
  showChartItemSummary = false;
  showNewActionCard = false;
  showSelect = false;
  newActionCardColumnWidth = 0;
  dashBoardColumnWidth = 12;
  customFieldsName: { key: string; name: string }[] | string[] = [];
  activeChartIndex = 1;
  fieldsIndex: number | null = null;
  groupByKey = "";
  groupBykeyDeep = "";
  anIncreasingNumber = 1;
  loadingData = false;
  loadingTable = false;
  displayResult = false;
  addTask = false;
  notificationDialog = false;
  editUserDataDialog = false;
  editMedicalOrderDialog = false;
  dialogAccept = false;
  flagOrderRequest = false;
  showModalMedicalOrder = false;

  masiveTaskResponse = false;
  reportTask: Array<ReportAddTaskData> = [];

  medicalOrder!: MedicalOrderPreviewEventTimelineModel;
  schema: FormSchema = { type: "object", allOf: [] };
  ordersSchema: FormSchema = { type: "object", allOf: [] };
  tableColumnsInput: TableHeader[] = [];
  orderTemplate: OrderTemplate = {} as OrderTemplate;
  newAction: ActionParameters = {} as ActionParameters;
  userInfoParams: NotificationParams[] = [];
  userRoleList: RoleInfo[] = [];
  dependenciesList: Dependency[] = [];
  dependenciesToRemoveList: Dependency[] = [];
  userDataSuccess: ActionError[] = [];
  userDataErrors: ActionError[] = [];
  userInfoGroups: HeaderInfoGroup[] = [];
  listData: OrderListDataView = {
    stateList: { data: [] },
    billType: { data: [] },
    campus: { data: [] },
    diagnosticPrimaryCode: { data: [] }
  };
  disabledFlag = false;
  listOfSearch: string[] = [];
  activateActionItem = {};
  selectFormFlag = false;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  tableHeaders = SERVICE_HEADERS;
  cardClass = STYLE_CLASSES.CARD;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  COLORS = SERVICE_STATE_COLORS;
  basicClass = STYLE_CLASSES.BASIC_PRIMARY;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  tableColumnsGroup: {
    name: string;
    key: string;
    allActive: boolean;
  }[] = [];

  EMPTY_STATE_HEADER = DASHBOARD_MESSAGES.NO_RESULTS;
  EMPTY_STATE_PARAGRAPH = DASHBOARD_MESSAGES.NOT_FOUND;
  userRoleListTask = [{ name: "", id: "", state: "" }];
  listObj: ObjList = { name: "", list: [] };
  filterArray: Filter[] = [];
  items: TreeChildren[] = [];
  fullSchema: FullSchema[] | Field[] = [];
  schemaTempUser: FullSchema[] = [];
  schemaTempForm: Field[] = [];
  orderDialog = false;
  userIdForOrderModal = "";
  masiveOrderModal = false;
  dashboardFilter: DashboardFilter = { collection: "" };
  selectedItem = {};

  sectionFilters: { [key: string]: any } = {
    service: {},
    form: {},
    medicalOrder: {},
    session: {},
    user: {},
    task: {}
  };
  oldSectionFilters: { [key: string]: any } = {
    service: {},
    form: {},
    medicalOrder: {},
    session: {},
    user: {},
    task: {}
  };
  columnsStatus: ColumnStatus[] = [];
  keyLocation = "";
  tempCups: List[] = [];
  currentGrouperKey = "";
  columnLastKey = "";
  lastSearchBarFilter = {};
  dataTableCounter = 1;
  filterStateActivation = lodash.cloneDeep(FILTER_STATE_ACTIVATION);
  isCleanReset = false;
  wasSearchByGrouper = false;
  wasSearchByGranularityWithoutGrouper = false;
  oldGroupIndex = 0;
  opentaskActionsModal = false;
  actionTask = "";
  cupsId = "";
  dashboardSearchName!: string;
  footerProps = { "items-per-page-options": [20, 50, 100] };
  page = 1;
  pageCount = 0;
  itemsPerPage = 0;
  options: { [key: string]: any } = { page: 1, itemsPerPage: 20 };
  metaData: PaginationData = {};
  totallItems = 0;
  downloadAndUpdateDialog = false;
  orderStates = ORDER_UPDATE_STATES;
  orderStateToUpdate = ORDER_STATES.COMPLETED;
  updateOrderStatus = false;
  ORDER_TO_UPDATE_CONST = UPDATE_ORDER_CONTANTS;
  openChangeStateModal = false;
  listNames: {
    [key: string]: { [key: string]: string | { key: string; name: string }[] };
  } = {
    services: {
      name: LIST_CONSTANTS.SERVICE_STATES_LIST_NAME,
      stateName: "state",
      states: []
    },
    users: {
      name: LIST_CONSTANTS.USERS_STATES_LIST_NAME,
      stateName: "state",
      states: []
    },
    medicalOrders: {
      name: LIST_CONSTANTS.ORDER_STATES_LIST_NAME,
      stateName: "orderState",
      states: []
    }
  };
  listOfServiceLevels: { templateId: string; key: string; name: string }[] = [];
  itemsSelectedOnTable = 0;

  async created() {
    const collection = String(
      this.$route.query.type || INITIAL_FILTER.collection
    );
    INITIAL_FILTER.collection = collection;
    this.currentMainFilter = collection;
    this.filterArray = lodash.cloneDeep(FILTERS_LIST).map(item => {
      if (item.mainFilterKey === collection) item.initial = true;
      return item;
    });
    store.commit(STORE_CONSTANTS.DASHBOARD_SEARCH_NAME, "");
    this.loadingData = true;
    this.loadingData = false;
    await this.getOrderTemplate();
    await this.getOrderTemplateSchema();
    await this.loadInfoGroupFieldsByName();
    await this.getRoles("");
    await this.getDependencies("");
    await this.getInfoGroups("");
  }

  async getOrderTemplate() {
    try {
      const responseData = await this.orderService.getTemplate();

      if (responseData.code == Http.Found && responseData.data !== undefined) {
        this.orderTemplate = responseData.data;
        for (const listRef of ORDER_CONSTANTS.DATA_LIST_NAMES) {
          if (responseData.data[listRef as keyof typeof responseData.data])
            await this.getListData(
              responseData.data[
                listRef as keyof typeof responseData.data
              ] as string,
              listRef
            );
        }
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ORDER_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getOrderTemplateSchema() {
    try {
      const responseData = await this.orderService.getOrderTempSchema();

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.schema = responseData.data;
        this.ordersSchema = lodash.cloneDeep(responseData.data);
        this.getEditableSchema();
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ORDER_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadInfoGroupFieldsByName() {
    try {
      const responseData = await this.infoGroupService.getInfoGroupFieldByName(
        INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_NAME
      );
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfoParams = responseData.data;
      } else {
        Snackbar.popInfo(USER_TEMP_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_GROUPS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getRoles(name: string) {
    try {
      const responseData = await this.rolesService.getRoles({
        state: FORM_CONSTANTS.LABEL.STATE,
        name: name !== "" ? name : null
      });

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userRoleList = responseData.data;
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_ROLES);
        this.userRoleList = [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getDependencies(name: string) {
    try {
      const responseData = await this.dependenciesService.getDependenciesWithFilters(
        {
          state: [STATE.ACTIVE],
          name: name !== "" ? name : undefined
        }
      );
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.dependenciesList = responseData.data.data;
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_ROLES);
        this.dependenciesList = [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getInfoGroups(name: string) {
    try {
      const responseData = await this.infoGroupService.getInfoGroupByFilters({
        state: DOCUMENT_STATES.ACTIVE,
        name: name !== "" ? name : undefined
      });

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfoGroups = responseData.data.groups;
      } else {
        Snackbar.popInfo(USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_GROUPS);
        this.userInfoGroups = [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getListData(id: string, name: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        responseData.data.options.forEach(option => {
          this.listData[name].data.push(
            option.title as string & { key: string; name: string }
          );
        });
      } else {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  serviceTypeTranslate(serviceTypeName: string) {
    return SERVICE_TYPE_TRANSLATE(serviceTypeName);
  }

  @Watch("currentChartItem")
  async deleteGrouperQuery() {
    try {
      if (this.currentChartItem) {
        this.increasingKeyCounter();
      }
      if (
        this.keyLocation &&
        this.currentGrouperKey &&
        !this.currentChartItem &&
        !this.isCleanReset &&
        this.currentMainFilter !== USERS &&
        !this.wasSearchByGranularityWithoutGrouper
      ) {
        if (this.keyLocation && this.currentGrouperKey) {
          delete this.sectionFilters[this.keyLocation][this.currentGrouperKey];
        }
        this.groupByArray = [];
        this.allTableData = [];
        this.tableColumnsGroup = [];
        this.currentTableData = [];
        this.listOfSearch = [];
        this.tableColumnsInput = [];
        this.setColumnsInput();
        this.resetValuesColumnsArray(this.columnsStatus);
        await this.getDashboardInfo(this.dashboardFilter);
        this.increasingKeyCounter();
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getListOfSpecialCasesInServices(
    location: string
  ): Promise<void | List[]> {
    try {
      let data: List[] = [];
      let listOfServiceTemplates = [];
      let listOfCups = [];
      switch (location) {
        case GROUPER_KEYS.SERVICE_INTERNAL_NAME:
          listOfServiceTemplates =
            (await this.getServiceTemplates(
              GROUPER_KEYS.SERVICE_INTERNAL_NAME
            )) ?? [];
          data = [...listOfServiceTemplates];
          break;
        case GROUPER_KEYS.CUPS:
          listOfCups = (await this.getCups(GROUPER_KEYS.CUPS)) ?? [];
          data = [...listOfCups];
          break;
      }
      return data;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getListOfSpecialCasesInForms(): Promise<void | List[]> {
    try {
      if (
        this.groupByArray[this.groupByTypeIndex].key ===
          GROUPER_KEYS.FORM_NAME ||
        this.groupByArray[this.groupByTypeIndex].key ===
          GROUPER_KEYS.TASK_FORM_TEMPLATE
      ) {
        return (
          (await this.getFormTemplates(GROUPER_KEYS.FORM_NAME)) ??
          ([] as List[])
        );
      }
      return [];
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getListOfSpecialCasesInSessions(): Promise<void | List[]> {
    try {
      if (this.groupByArray[this.groupByTypeIndex].key === GROUPER_KEYS.NAME) {
        return (
          (await this.getAllSessionTemplates(GROUPER_KEYS.NAME)) ??
          ([] as List[])
        );
      }
      return [];
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async addServiceGrouperIntoFilter(locationFilter: string) {
    let serviceKey = "";
    const currentGroupFilter = this.groupByArray[this.groupByTypeIndex] ?? "";
    const convertToSearchKey = GROUP_BY_FIELDS_SERVICE.find(
      serviceField => serviceField.value === currentGroupFilter.key
    );

    const listOfValues = await this.getListOfSpecialCasesInServices(
      this.groupByArray[this.groupByTypeIndex].key
    );

    if (this.currentChartItem) {
      if ((listOfValues as List[]).length > 0) {
        const serviceTempKey = (listOfValues as List[]).find(each =>
          each.name.includes(this.currentChartItem)
        );
        if (serviceTempKey) {
          serviceKey = serviceTempKey.key;
        }
      }
      if (convertToSearchKey) {
        this.wasSearchByGrouper = true;
        this.sectionFilters[locationFilter][convertToSearchKey.convert] = [
          !serviceKey ? this.currentChartItem : serviceKey
        ];
      }
    }

    this.currentGrouperKey = convertToSearchKey?.convert ?? "";
  }

  async addMedicalOrderGrouperIntoFilter(locationFilter: string) {
    let medicalOrderKey = "";
    const currentGroupFilter = this.groupByArray[this.groupByTypeIndex] ?? "";
    const convertToSearchKey = GROUP_BY_FIELDS_MEDICAL_ORDERS.find(
      medicalOrderField => medicalOrderField.value === currentGroupFilter.key
    );

    const listOfValues = await this.getListOfSpecialCasesInServices(
      this.groupByArray[this.groupByTypeIndex].key
    );

    if (this.currentChartItem) {
      if ((listOfValues as List[]).length > 0) {
        const medicalOrderTempKey = (listOfValues as List[]).find(each =>
          each.name.includes(this.currentChartItem)
        );
        if (medicalOrderTempKey) {
          medicalOrderKey = medicalOrderTempKey.key;
        }
      }
      if (convertToSearchKey) {
        this.wasSearchByGrouper = true;
        this.sectionFilters[locationFilter][convertToSearchKey.convert] = [
          !medicalOrderKey ? this.currentChartItem : medicalOrderKey
        ];
      }
    }
    this.currentGrouperKey = convertToSearchKey?.convert ?? "";
  }

  async addTaskGrouperIntoFilter(locationFilter: string) {
    let taskKey = "";
    const currentGroupFilter = this.groupByArray[this.groupByTypeIndex] ?? "";
    const listOfValues = await this.getListOfSpecialCasesInForms();
    const convertToSearchKey = GROUP_BY_FIELDS_TASK.find(
      taskField => taskField.value === currentGroupFilter.key
    );

    if (this.currentChartItem && convertToSearchKey) {
      const taskTempKeys = (listOfValues as List[]).find(each =>
        each.name.toLowerCase().includes(this.currentChartItem.toLowerCase())
      );
      if (taskTempKeys) taskKey = taskTempKeys.key;
      this.wasSearchByGrouper = true;
      this.sectionFilters[locationFilter][convertToSearchKey.convert] = [
        !taskKey ? this.currentChartItem : taskKey
      ];
    }

    this.currentGrouperKey = convertToSearchKey?.convert ?? "";
  }

  async addFormsGrouperIntoFilter(locationFilter: string) {
    let formKey = "";
    const currentGroupFilter = this.groupByArray[this.groupByTypeIndex] ?? "";
    const listOfValues = await this.getListOfSpecialCasesInForms();
    const convertToSearchKey = GROUP_BY_FIELDS_FORMS.find(
      formField => formField.value === currentGroupFilter.key
    );

    if (this.currentChartItem && convertToSearchKey) {
      const formTempKeys = (listOfValues as List[]).find(each =>
        each.name.toLowerCase().includes(this.currentChartItem.toLowerCase())
      );

      if (formTempKeys) formKey = formTempKeys.key;
      this.wasSearchByGrouper = true;
      this.sectionFilters[locationFilter][convertToSearchKey.convert] = [
        !formKey ? this.currentChartItem : formKey
      ];
    }

    this.currentGrouperKey = convertToSearchKey?.convert ?? "";
  }

  async addSessionGrouperIntoFilter(locationFilter: string) {
    let sessionTemp = "";
    const currentGroupFilter = this.groupByArray[this.groupByTypeIndex] ?? "";

    const convertToSearchKey = GROUP_BY_FIELDS_SESSIONS.find(
      sessionField => sessionField.value === currentGroupFilter.key
    );
    const listOfValues = await this.getListOfSpecialCasesInSessions();

    if (this.currentChartItem) {
      if (((listOfValues as List[]) ?? []).length > 0) {
        const sessionTempKey = (listOfValues as List[])?.find(each =>
          each.name.toLowerCase().includes(this.currentChartItem.toLowerCase())
        );
        if (sessionTempKey) {
          sessionTemp = sessionTempKey.key;
        }
      }
      if (convertToSearchKey) {
        this.wasSearchByGrouper = true;
        this.sectionFilters[locationFilter][convertToSearchKey.convert] = [
          !sessionTemp ? this.currentChartItem : sessionTemp
        ];
      }
    }

    this.currentGrouperKey = convertToSearchKey?.convert ?? "";
  }

  async handleGrouper(location: string) {
    if (location) {
      const handler = {
        service: async () => await this.addServiceGrouperIntoFilter(location),
        medicalOrder: async () =>
          await this.addMedicalOrderGrouperIntoFilter(location),
        form: async () => await this.addFormsGrouperIntoFilter(location),
        session: async () => await this.addSessionGrouperIntoFilter(location),
        task: async () => await this.addTaskGrouperIntoFilter(location)
      };
      return await (handler as any)[location]();
    }
    return;
  }

  changeFilters(filter: { [key: string]: any }) {
    let extraAttributesForSectionFilter = {};
    if (filter[ATTRIBUTES_OF_DASHBOARD_FILTER_OBJECT.filterDate]) {
      extraAttributesForSectionFilter = {
        ...extraAttributesForSectionFilter,
        filterDate: filter[ATTRIBUTES_OF_DASHBOARD_FILTER_OBJECT.filterDate]
      };
    }

    if (filter[ATTRIBUTES_OF_DASHBOARD_FILTER_OBJECT.dateStart]) {
      extraAttributesForSectionFilter = {
        ...extraAttributesForSectionFilter,
        dateStart: filter[ATTRIBUTES_OF_DASHBOARD_FILTER_OBJECT.dateStart]
      };
    }
    if (filter[ATTRIBUTES_OF_DASHBOARD_FILTER_OBJECT.dateEnd]) {
      extraAttributesForSectionFilter = {
        ...extraAttributesForSectionFilter,
        dateEnd: filter[ATTRIBUTES_OF_DASHBOARD_FILTER_OBJECT.dateEnd]
      };
    }
    const location = Object.keys(filter).filter(
      section => !ATTRIBUTES_OF_DASHBOARD_FILTER.includes(section)
    );
    this.keyLocation = location[0];
    this.sectionFilters[location[0]] = {
      ...filter[location[0]]
    };
    this.sectionFilters = {
      ...this.sectionFilters,
      ...extraAttributesForSectionFilter
    };

    this.resetValuesColumnsArray(this.columnsStatus);
  }

  changeValueColumnsArray(iterator: ColumnStatus[], key: string) {
    iterator.forEach(column => {
      if (column.key === key) {
        column.value = true;
      }
    });
  }

  resetValuesColumnsArray(iterator: ColumnStatus[]) {
    iterator.forEach(column => (column.value = false));
  }

  getGroupByArrayFromChart(chartData: ChartData) {
    return Object.entries(chartData).map(([key, values]) => {
      return {
        key,
        name: values.name ?? DASHBOARD_LABELS.FIELDS_LABEL,
        deepLevel: values.deepLevel
      };
    });
  }

  async getFilteredDashboardInfo(key: string) {
    const columnValidation = this.columnsStatus.filter(
      column => column.key === key
    );

    if (!columnValidation[0].value) {
      if (TAG_FILTER_NAMES.includes(key)) {
        this.filterStateActivation[key] = true;
      }
      this.listOfSearch = [];
      Object.entries(this.filterStateActivation).forEach(value => {
        if (value[1] === true) {
          this.listOfSearch.push(value[0]);
        }
      });
      if (
        MAIN_FILTER[this.currentMainFilter] === key ||
        (this.currentMainFilter === FILTERED_DASHBOARD_TAGS.SERVICES &&
          key === MAIN_FILTER.medicalOrders)
      )
        return;
      try {
        await this.handleGrouper(this.keyLocation);
        this.disabledFlag = true;
        const filter = {
          ...this.sectionFilters,
          collection: this.currentMainFilter,
          services: FILTERED_DASHBOARD_TAGS.SEARCH,
          listOfSearch: [...this.listOfSearch]
        };
        const response = await this.dashboardService.getCollectionFilterData(
          filter
        );
        this.disabledFlag = false;
        if (
          this.currentMainFilter === FILTERED_DASHBOARD_TAGS.SERVICES &&
          key === MAIN_FILTER.users &&
          !this.flagOrderRequest
        ) {
          await this.getAdditionalColumnsData(key);
          this.flagOrderRequest = true;
        }

        if (response.code === Http.Found && !!response.data) {
          this.activateActionItem = {
            key
          };
          if (
            this.currentMainFilter === FILTERED_DASHBOARD_TAGS.FORMS &&
            key === MAIN_FILTER.users
          ) {
            this.selectFormFlag = true;
          }
          this.groupByKey = this.groupByKeys[this.groupByTypeIndex];

          let value: TableField[] = [];
          this.totallItems = response.data.meta.total || 0;
          response.data.table.forEach(b => {
            const filterFile = this.allTableData.filter(a => a._key === b._key);
            value = [
              ...value,
              {
                ...filterFile[0],
                ...b
              }
            ];
          });
          this.currentTableData = this.currentTableData.map((data, index) => {
            return {
              ...data,
              ...value[index]
            };
          });
          if (this.allTableData.length === this.currentTableData.length) {
            this.allTableData = [...this.currentTableData];
          }
          if (!this.currentChartItem) {
            this.wasSearchByGranularityWithoutGrouper = true;
          }
        }
        this.changeValueColumnsArray(this.columnsStatus, key);
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden)
          Snackbar.popError(
            FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.GET
          );
        else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }
  async getDashboardInfo(filter: DashboardFilter) {
    try {
      this.loadingData = true;
      this.showChartItemSummary = false;
      this.options.page = INIT_PAGE;
      const response = await this.dashboardService.getCollectionFilter(filter);
      if (response.code === Http.Found && !!response.data) {
        this.groupByArray = this.getGroupByArrayFromChart(response.data.chart);
        this.groupByKeys = Object.keys(response.data.chart);
        this.allChartData = response.data.chart;
        this.allTableData = response.data.table;
        this.totallItems = response.data.meta.total || 0;
        this.metaData = response.data.meta;
        this.groupByKey = this.groupByKeys[this.groupByTypeIndex];
        this.chartData = {
          labels: this.allChartData[this.groupByKey].labels,
          datasets: [
            {
              data: this.allChartData[this.groupByKey].values
            }
          ],
          extraInfo: this.allChartData[this.groupByKey].extraInfo
        };

        this.currentTableData = this.allTableData;

        if (filter.collection == COLLECTIONS.ORDER)
          this.formatOrderCustomFieldsData();
        this.setColumnsInput();
        this.setColumnGroup();
        this.setColumnGroupSelector();
        this.columnsStatus = this.tableColumnsGroup.map(a => {
          return {
            key: a.name,
            value: false
          };
        });
        this.loadingData = false;
        this.displayResult = true;
      } else {
        this.loadingData = false;
        this.displayResult = false;
      }
      this.currentGrouperKey = "";
      this.currentChartItem = "";
      Object.keys((this.dashboardFilter as any)[this.keyLocation]).forEach(
        key => {
          if (!this.sectionFilters[this.keyLocation][key]) {
            delete this.sectionFilters[this.keyLocation][key];
          }
        }
      );
      this.wasSearchByGrouper = false;
    } catch (error) {
      this.loadingData = false;
      this.displayResult = false;
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async getDashboardInfoData(filter: DashboardFilter) {
    try {
      console.log("filter", filter);

      this.getStatesByCollection(filter);
      this.loadingTable = true;
      const response = await this.dashboardService.getCollectionFilterData(
        filter
      );
      if (response.code === Http.Found && !!response.data) {
        this.allTableData = response.data.table;
        this.totallItems = response.data.meta.total || 0;
        this.metaData = response.data.meta;
        if (filter.collection == COLLECTIONS.ORDER)
          this.formatOrderCustomFieldsData();

        this.currentTableData = this.allTableData;
        if (this.sortBy) this.sortTableData();
      }
      if (response.code === Http.NotFound) {
        this.allTableData = [];
        this.totallItems = 0;
        this.metaData = {};
        this.currentTableData = [];
      }
    } catch (error) {
      this.displayResult = false;
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    this.loadingTable = false;
  }

  @Watch("options")
  async changeOptions(newData: any, oldData: any) {
    const sortChange = this.validateSortChange(newData, oldData);
    if (
      newData.page != oldData.page ||
      newData.itemsPerPage != oldData.itemsPerPage
    ) {
      if (
        newData.page == oldData.page ||
        newData.itemsPerPage != oldData.itemsPerPage ||
        (newData.page != oldData.page && sortChange)
      ) {
        await this.getDashboardInfoData({
          ...this.dashboardFilter,
          services: FILTERED_DASHBOARD_TAGS.SEARCH,
          listOfSearch: [...this.listOfSearch],
          rows: newData.itemsPerPage
        });
      } else if (
        newData.page > oldData.page &&
        newData.itemsPerPage == oldData.itemsPerPage
      ) {
        await this.getDashboardInfoData({
          ...this.dashboardFilter,
          services: FILTERED_DASHBOARD_TAGS.SEARCH,
          listOfSearch: [...this.listOfSearch],
          lastRef: this.metaData.lastRef,
          rows: newData.itemsPerPage
        });
      } else if (
        newData.page < oldData.page &&
        newData.itemsPerPage == oldData.itemsPerPage
      ) {
        await this.getDashboardInfoData({
          ...this.dashboardFilter,
          services: FILTERED_DASHBOARD_TAGS.SEARCH,
          listOfSearch: [...this.listOfSearch],
          firstRef: this.metaData.firstRef,
          rows: newData.itemsPerPage
        });
      }
    }
    if (sortChange) this.sortTableData();
  }

  validateSortChange(newData: any, oldData: any) {
    if (newData.sortBy.length > 0 && newData.sortDesc.length > 0) {
      if (
        newData.sortBy[0] != oldData.sortBy[0] ||
        newData.sortDesc[0] != oldData.sortDesc[0]
      ) {
        this.sortBy = newData.sortBy[0];
        this.sortDesc = newData.sortDesc[0];
        return true;
      }
    } else {
      this.sortBy = "";
      this.sortDesc = "";
    }
    return false;
  }

  sortTableData() {
    this.currentTableData = this.currentTableData.sort((a: any, b: any) => {
      const sortA = (a[this.sortBy] ?? "").toString().toUpperCase();
      const sortB = (b[this.sortBy] ?? "").toString().toUpperCase();
      if (sortA < sortB) return this.sortDesc ? 1 : -1;
      if (sortA > sortB) return this.sortDesc ? -1 : 1;
      return 0;
    });
  }

  async acceptNotification(notificationConfig: NotificationConfig) {
    this.dashboardFilter.bigSearch =
      this.selectedTableData.length == this.currentTableData.length;
    this.notificationDialog = false;
    this.loadingData = true;
    this.showChartItemSummary = false;
    const newAction: ActionParameters = {
      ids: this.userIdArray,
      notifications: [notificationConfig],
      type: ACTION_EVENT.NOTIFICATION,
      dashboardFilter: this.dashboardFilter
    };
    this.tableColumnsGroup = [];
    await this.sendAction(newAction);
  }

  async sendAction(newAction: ActionParameters) {
    try {
      const responseData = await this.dashboardService.applyUserActions(
        newAction
      );

      if (responseData.code == Http.PartialContent && responseData.data) {
        this.userDataErrors = responseData.data.errors;
        this.userDataSuccess = responseData.data.success;
        Snackbar.popSuccess(responseData.message);
      } else if (
        responseData.code == Http.Ok &&
        newAction.task &&
        newAction.task.formTemplate != ""
      ) {
        Snackbar.popSuccess(responseData.message);
        this.toggleNewActionCard();
        this.reportTask = responseData.data?.data;
        this.masiveTaskResponse = true;
      } else if (responseData.code == Http.Ok && responseData.data) {
        this.userDataSuccess = responseData.data.success;
        Snackbar.popSuccess(responseData.message);
      } else if (
        responseData.code == Http.PartialContent ||
        responseData.code == Http.Ok
      ) {
        Snackbar.popSuccess(responseData.message);
        this.toggleNewActionCard();
      } else {
        this.userDataErrors =
          responseData.data && responseData.data.errors
            ? responseData.data.errors
            : [];
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async getAdditionalColumnsData(key: string) {
    const itemsKeys = this.currentTableData.map(item => item._key);
    this.loadingTable = true;
    try {
      const response = await this.dashboardService.getExtraCollectionData({
        collection: DASBOARD_CURRENT_FILTER.ORDERS,
        ids: itemsKeys
      });
      if (response.code === Http.Found && !!response.data) {
        this.currentTableData = response.data.map((element, index) => ({
          ...this.currentTableData[index],
          ...element[0]
        }));
        this.tableColumnsInput = this.tableColumnsInput.map(
          (element: TableHeader) => ({
            ...element,
            searched: element.type === key
          })
        );
        this.loadingTable = false;
      } else {
        Snackbar.popInfo(DASHBOARD_MESSAGES.FIELD_NOT_FOUND);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  setColumnGroupSelector() {
    this.tableColumnsInput.forEach((element: TableHeader) => {
      if (element.active === false) {
        const index = this.tableColumnsGroup.findIndex(
          column => column.key === element.type
        );
        this.tableColumnsGroup[index].allActive = false;
      }
    });
  }

  setColumnGroup() {
    const keys = this.tableColumnsInput.map(column => column.type);
    const uniqueKeys = [...new Set(keys)];

    uniqueKeys.forEach(key =>
      this.tableColumnsGroup.push({
        key,
        name: this.getColumnGroupName(key),
        allActive: true
      })
    );
  }

  formatOrderCustomFieldsData() {
    this.allTableData.forEach((item: TableField) => {
      const medicalOrderFields = item.medicalOrderFields as MedicalOrderFieldsMap;
      const keys = Object.keys(medicalOrderFields);
      if (keys.length > 0) {
        keys.forEach(key => {
          if (medicalOrderFields[key]) {
            Object.assign(item, {
              [key]: medicalOrderFields[key].value
            });
          }
        });
      }
    });
  }

  cleaningColumnsInput() {
    this.tableColumnsInput.forEach(a => {
      if (
        !(
          this.currentMainFilter.toLowerCase().includes(a.type.toLowerCase()) ||
          a.type.toLowerCase().includes(this.currentMainFilter.toLowerCase())
        )
      ) {
        a.active = false;
      }
    });
  }

  async searchWithFilter(filter: DashboardFilter) {
    this.setFilterArray(filter.collection);
    this.isCleanReset = true;
    this.sectionFilters = {
      service: {},
      form: {},
      medicalOrder: {},
      session: {}
    };
    this.changeFilters(filter);
    this.dashboardFilter = filter;
    await this.getServiceLevels(DATA_TYPE_CONSULT.SERVICE.SERVICE_LEVEL);
    this.activateActionItem = {
      key: null
    };
    const tagsFilter = Object.keys(this.filterStateActivation);
    tagsFilter.forEach(tag => {
      this.filterStateActivation[tag] = false;
    });
    this.selectFormFlag = false;
    this.cleaningColumnsInput();
    this.flagOrderRequest = false;
    this.currentTableData = [];
    this.listOfSearch = [];
    this.groupByTypeIndex = DEFAULT_GROUP_BY_TYPE_INDEX;
    this.selectedTableData = [];
    this.groupBykeyDeep = "";
    this.currentChartItem = "";
    this.currentMainFilter = this.dashboardFilter.collection;
    this.wasSearchByGranularityWithoutGrouper = false;
    this.tableColumnsGroup = [];
    this.groupByArray = [];
    this.allTableData = [];
    this.tableColumnsInput = [];
    this.setColumnsInput();
    this.resetValuesColumnsArray(this.columnsStatus);
    await this.getDashboardInfo(this.dashboardFilter);
    this.increasingKeyCounter();
    this.isCleanReset = false;
  }

  setColumnsInput() {
    const types: { [key: string]: () => TableHeader[] } = {
      medicalOrders: () => this.setVisibleOrderFields(),
      services: () => lodash.cloneDeep(SERVICE_HEADERS),
      forms: () => lodash.cloneDeep(FORMS_HEADERS),
      users: () => lodash.cloneDeep(USERS_HEADERS),
      sessions: () => lodash.cloneDeep(SESSION_HEADERS),
      tasks: () => lodash.cloneDeep(TASKS_HEADERS)
    };
    const type = types[this.currentMainFilter];
    if (type !== undefined) {
      this.tableColumnsInput = types[this.currentMainFilter]();
    } else {
      Snackbar.popError(ACTION_MESSAGE.FAILED);
    }
  }

  setVisibleOrderFields() {
    let orderHeader = lodash.cloneDeep(ORDER_HEADERS);
    const customOrderFieldsHeaders = this.formatCustomOrderFieldsHeaders();
    orderHeader = [...orderHeader, ...customOrderFieldsHeaders];

    orderHeader = orderHeader.filter(
      item =>
        item.type != TABLE_COLUMNS_GROUP_FILTER.ORDER ||
        this.orderTemplate.dashboardVisibleFields?.includes(item.value) ||
        item.value == ACTIONS_VALUE
    );

    return orderHeader;
  }

  formatCustomOrderFieldsHeaders() {
    let customOrderFieldsHeaders: any[] = [];
    if (this.ordersSchema.allOf.length > 0) {
      const medicalOrderFields = this.ordersSchema.allOf[0].properties;
      const keys = Object.keys(medicalOrderFields);

      customOrderFieldsHeaders = keys.map(key => {
        return {
          value: key,
          text: medicalOrderFields[key].title,
          type: TABLE_COLUMNS_GROUP_FILTER.ORDER,
          active: true,
          localKey: true,
          width: "170px"
        };
      });
    }
    return customOrderFieldsHeaders;
  }

  getColumnGroupName(key: string) {
    const types: { [key: string]: () => string } = {
      order: () => FORM_CONSTANTS.MENU_BAR.ORDERS,
      service: () => FORM_CONSTANTS.MENU_BAR.SERVICES,
      form: () => FORM_CONSTANTS.MENU_BAR.FORMS,
      user: () => FORM_CONSTANTS.MENU_BAR.USERS,
      session: () => FORM_CONSTANTS.MENU_BAR.SESSIONS,
      task: () => FORM_CONSTANTS.MENU_BAR.TASKS
    };
    return types[key]();
  }

  validateOrdersWithService() {
    if (
      this.currentMainFilter === DASBOARD_CURRENT_FILTER.ORDERS &&
      this.groupByKey === "serviceInternalName"
    )
      return true;
    return false;
  }
  validatFormsWithService() {
    if (this.currentMainFilter === "forms" && this.groupByKey === "fields")
      return true;
    return false;
  }
  validateSessionsWithUser() {
    if (
      this.currentMainFilter === "sessions" &&
      ["userGender", "userDocumentType"].includes(this.groupByKey)
    )
      return true;
    return false;
  }

  async grouperValidators() {
    if (
      this.keyLocation &&
      this.currentGrouperKey &&
      this.currentMainFilter !== USERS
    ) {
      delete this.sectionFilters[this.keyLocation][this.currentGrouperKey];
    }
    if (
      !this.validateOrdersWithService() &&
      !this.validateSessionsWithUser() &&
      !this.validatFormsWithService() &&
      this.listOfSearch.length > 0 &&
      this.currentMainFilter !== USERS &&
      !this.wasSearchByGranularityWithoutGrouper
    ) {
      if (this.currentChartItem) {
        this.groupByArray = [];
        this.allTableData = [];
        this.tableColumnsGroup = [];
        this.currentTableData = [];
        this.listOfSearch = [];
        this.tableColumnsInput = [];
        this.setColumnsInput();
        this.resetValuesColumnsArray(this.columnsStatus);
        await this.getDashboardInfo(this.dashboardFilter);
      }
      this.increasingKeyCounter();
    }
    this.validateTableColumnsGroupChecked();
  }

  @Watch("groupByTypeIndex")
  async setChartInformation() {
    if (
      this.oldGroupIndex !== this.groupByTypeIndex &&
      this.currentMainFilter === FILTERED_DASHBOARD_TAGS.SERVICES
    ) {
      this.flagOrderRequest = false;
    }
    this.groupByKey = this.groupByKeys[this.groupByTypeIndex];
    this.showChartItemSummary = false;

    if (this.groupByKey === "fields") {
      this.customFieldsName = Object.entries(
        (this.allChartData[this.groupByKey] as unknown) as ChartData
      ).map(([key, value]) => {
        return { key, name: value.name };
      });
    } else {
      this.chartData = {
        labels: this.allChartData[this.groupByKey].labels,
        datasets: [
          {
            data: this.allChartData[this.groupByKey].values
          }
        ],
        extraInfo: this.allChartData[this.groupByKey].extraInfo
      };
      this.fieldsIndex = null;
      if (
        !this.validateOrdersWithService() &&
        !this.validatFormsWithService() &&
        !this.validateSessionsWithUser()
      ) {
        this.cleanChartItem();
      }
    }
    await this.grouperValidators();
    this.oldGroupIndex = this.groupByTypeIndex;
  }

  @Watch("fieldsIndex")
  setChartInformationFromFields() {
    this.showChartItemSummary = false;
    if (this.fieldsIndex !== null) {
      const key = (this.customFieldsName as { key: string; name: string }[])[
        this.fieldsIndex as number
      ].key;
      this.chartData = {
        labels: ((this.allChartData[this.groupByKey] as unknown) as ChartData)[
          key
        ].labels,
        datasets: [
          {
            data: ((this.allChartData[
              this.groupByKey
            ] as unknown) as ChartData)[key].values
          }
        ]
      };
    }
  }

  changeChartType(chartType: string, index: number) {
    this.activeChartIndex = index;
    this.currentChartType = chartType;
  }

  filterTypeChartByArrayObjectKeyNameSafe(label: string) {
    this.currentTableData = this.allTableData.filter(data => {
      if (Object.prototype.hasOwnProperty.call(data, this.groupByKey)) {
        const groups = (data[
          this.groupByKey as keyof TableField
        ] as unknown) as Array<{ key: string; name: string }>;
        if (
          typeof groups === KEYTYPE_CONSTANTS.OBJECT ||
          Array.isArray(groups)
        ) {
          if (Object.keys(groups).length === 0) {
            return label === NO_GROUP_LABEL;
          }
          for (const iterator in groups) {
            if (groups[iterator]?.name) {
              const found = groups[iterator].name === label;
              if (found) return found;
            }
          }
        }
        return false;
      } else {
        return label === UNRATED_OR_NOAPPLY;
      }
    });
  }

  filterTypeChartByArrayObjectKeyNameSafeWithDeepRef(
    label: string,
    ref: string
  ) {
    this.currentTableData = this.allTableData.filter(data => {
      let iteratorItemRef = 0,
        itemEquality = null;
      do {
        itemEquality = Utils.findItemByRef(
          ref.replace("$", iteratorItemRef.toString()),
          data
        );
        if (itemEquality?.name === label) return true;
        if (itemEquality === label) return true;

        ++iteratorItemRef;
      } while (itemEquality !== null);

      return label === UNRATED_OR_NOAPPLY;
    });
  }

  filterTypeChartByArrayObjectKeyName(label: string) {
    this.currentTableData = this.allTableData.filter(data => {
      const groups = (data[
        this.groupByKey as keyof TableField
      ] as unknown) as Array<{ key: string; name: string }>;

      const found = groups.find(group => group.name === label);
      return found;
    });
  }

  filterTypeChartByArray(label: string) {
    this.currentTableData = this.allTableData.filter(data => {
      const services = (data[
        this.groupByKey as keyof TableField
      ] as unknown) as string[];
      return services.includes(label);
    });
  }

  updateChartInformationByArray(array: any, deepFilters: string) {
    const groupByDeepLevelKeys = Object.keys(array);
    this.groupBykeyDeep = deepFilters;
    this.chartData = {
      labels: groupByDeepLevelKeys,
      datasets: [
        {
          data: Object.values(array)
        }
      ]
    };
    this.showChartItemSummary = false;
  }

  filterTypeChart(label: string) {
    const customFilterTypes: FilterTypeListChart = {
      users: {
        userRoles: () => {
          this.filterTypeChartByArray(label);
        },
        assignedServices: () => {
          this.filterTypeChartByArray(label);
        },
        serviceGroups: () => {
          this.filterTypeChartByArrayObjectKeyName(label);
        },
        serviceSections: () => {
          this.filterTypeChartByArrayObjectKeyName(label);
        }
      },
      services: {
        groupsFilled: () => {
          this.filterTypeChartByArrayObjectKeyNameSafe(label);
        },
        session: () => {
          this.filterTypeChartByArrayObjectKeyNameSafeWithDeepRef(
            label,
            FILTER_CONSTANTS.GROUPSECTION_SESSION
          );
          const groupBy = this.groupByArray.find(
            group => group.key === this.groupByKey
          );
          if (groupBy?.deepLevel) {
            let founded = false;
            for (const it in groupBy.deepLevel) {
              let iteratorItemRef = 0,
                itemEquality = null;
              do {
                itemEquality = Utils.findItemByRef(
                  FILTER_CONSTANTS.SESSION_QUALIFICATION_DEEPLABEL.replace(
                    "$",
                    iteratorItemRef.toString()
                  ),
                  groupBy.deepLevel[it]
                );
                if (itemEquality === label) {
                  founded = true;
                  break;
                }
                ++iteratorItemRef;
              } while (itemEquality !== null);
              if (founded) {
                this.updateChartInformationByArray(
                  Utils.findItemByRef(
                    FILTER_CONSTANTS.SESSION_QUALIFICATION_DEEPVALUE.replace(
                      "$",
                      iteratorItemRef.toString()
                    ),
                    groupBy.deepLevel[it]
                  ),
                  FILTER_CONSTANTS.QUALIFICATION
                );
                break;
              }
            }
          }
        },
        qualification: () => {
          this.filterTypeChartByArrayObjectKeyNameSafeWithDeepRef(
            label,
            FILTER_CONSTANTS.GROUPSECTION_SESSIONQUALIFICATION
          );
        }
      }
    };

    const filterTypeList = customFilterTypes[this.currentMainFilter];

    const filterTypeChart =
      filterTypeList !== undefined
        ? this.groupBykeyDeep !== ""
          ? filterTypeList[this.groupBykeyDeep]
          : filterTypeList[this.groupByKey]
        : undefined;

    if (filterTypeChart !== undefined) {
      filterTypeChart();
    } else {
      const tableWithoutChanges = lodash.cloneDeep(
        this.currentTableData
      ) as TableField[];
      this.currentTableData = (this.innerGrouperValidations()
        ? tableWithoutChanges
        : this.allTableData
      ).filter(
        data =>
          (data[this.groupByKey as keyof TableField] as string)?.trim() ===
          label.trim()
      );
    }
    const currentChartLabelIndex = this.chartData.labels.findIndex(
      each => each == label
    );
    if (currentChartLabelIndex >= 0) {
      this.chartData = {
        labels: [this.chartData.labels[currentChartLabelIndex]],
        datasets: [
          {
            data: [this.chartData.datasets[0].data[currentChartLabelIndex]]
          }
        ],
        extraInfo: this.chartData.extraInfo
      };
    }
  }

  innerGrouperValidations() {
    const validateCurrentMainFilter = MAIN_FILTER_FOR_INNER_GROUPING.includes(
      this.currentMainFilter
    );
    const validateInnerGroupers = INNER_GROUPERS.includes(this.groupByKey);
    return (
      (validateCurrentMainFilter &&
        validateInnerGroupers &&
        this.listOfSearch.length > 0) ||
      !this.wasSearchByGranularityWithoutGrouper
    );
  }

  async chartClick(label: string) {
    this.oldSectionFilters = JSON.parse(JSON.stringify(this.dashboardFilter));
    this.sectionFilters = JSON.parse(JSON.stringify(this.dashboardFilter));
    if (this.convertField) {
      delete this.oldSectionFilters[this.keyLocation][this.convertField];
      delete this.sectionFilters[this.keyLocation][this.convertField];
    }
    this.showChartItemSummary = true;
    this.currentChartItem = label;
    this.convertField = this.getCollectionField() || this.groupByKey;
    this.sectionFilters[this.keyLocation][this.convertField] = [label];
    this.dashboardFilter = {
      ...this.dashboardFilter,
      ...this.sectionFilters,
      rows: this.options.itemsPerPage
    };
    await this.getDashboardInfoData({
      ...this.dashboardFilter,
      services: FILTERED_DASHBOARD_TAGS.SEARCH,
      listOfSearch: [...this.listOfSearch]
    });
    this.options.page = INIT_PAGE;
    const currentChartLabelIndex = this.chartData.labels.findIndex(
      each => each == label
    );
    if (currentChartLabelIndex >= 0) {
      this.chartData = {
        labels: [this.chartData.labels[currentChartLabelIndex]],
        datasets: [
          {
            data: [this.chartData.datasets[0].data[currentChartLabelIndex]]
          }
        ],
        extraInfo: this.chartData.extraInfo
      };
    }
  }

  getCollectionField() {
    const groupByFields: any = { ...GROUP_BY_FIELDS_BY_COLLECTION };
    const groupers = groupByFields[this.keyLocation];
    if (groupers) {
      const filter = groupers.find(
        (field: any) => field.value === this.groupByKey
      );
      return filter ? filter.convert : this.groupByKey;
    }
    return this.groupByKey;
  }

  async chartClickOut() {
    if (this.convertField) {
      this.sectionFilters = JSON.parse(JSON.stringify(this.oldSectionFilters));
      this.dashboardFilter = {
        ...this.dashboardFilter,
        ...this.oldSectionFilters,
        rows: this.options.itemsPerPage
      };
      await this.getDashboardInfoData({
        ...this.dashboardFilter,
        services: FILTERED_DASHBOARD_TAGS.SEARCH,
        listOfSearch: [...this.listOfSearch]
      });
      this.options.page = INIT_PAGE;
      this.chartData = {
        labels: this.allChartData[this.groupByKey].labels,
        datasets: [
          {
            data: this.allChartData[this.groupByKey].values
          }
        ],
        extraInfo: this.allChartData[this.groupByKey].extraInfo
      };
      this.cleanChartItem();
      this.convertField = "";
    }
  }

  updateTableColumnsGroup(groupKey: string, newValues: any) {
    const groupIndex = this.tableColumnsGroup.findIndex(
      group => group.key === groupKey
    );
    if (groupIndex !== -1) {
      const updatedGroup = {
        ...this.tableColumnsGroup[groupIndex],
        ...newValues
      };
      this.tableColumnsGroup.splice(groupIndex, 1, updatedGroup);
    } else {
      const newGroup = { ...newValues, key: groupKey };
      this.tableColumnsGroup.push(newGroup);
    }
  }

  removeObjectsWithoutName() {
    this.tableColumnsGroup = this.tableColumnsGroup.filter(
      group => group.name != null
    );
  }

  async cleanChartItem() {
    this.showChartItemSummary = false;
    const filters = COLUMN_FILTER_UPDATE[this.currentMainFilter] || [];

    filters.forEach(({ group, allActive }) => {
      this.updateTableColumnsGroup(group, { allActive });
    });
    this.removeObjectsWithoutName();
    this.currentTableData = this.allTableData;
    this.increasingKeyCounter();
  }

  getToFix(valueFix?: any) {
    return valueFix ? `${Number(valueFix).toFixed(1)} %` : 0;
  }

  async selectAllColumnGroup(key: string) {
    const columnGroup = this.tableColumnsGroup.find(
      column => column.key === key
    );
    if (!columnGroup) return;

    this.loadingTable = true;

    const { allActive } = columnGroup;
    this.tableColumnsInput
      .filter(column => column.type === key)
      .forEach(column => {
        column.active = allActive;
      });
    await this.selectColumn(key);
    this.loadingTable = false;
  }

  async selectColumn(key: string) {
    const index = this.tableColumnsGroup.findIndex(
      column => column.key === key
    );
    const falsies = this.tableColumnsInput.filter(
      (column: TableHeader) => column.active === false && column.type === key
    );
    this.tableColumnsGroup[index].allActive =
      falsies.length === 0 ? true : false;

    const foreignKeys = this.tableColumnsInput.filter(
      (column: TableHeader) =>
        column.localKey === false &&
        column.searched === false &&
        column.type === key
    );
    if (foreignKeys.length > 0 && !this.flagOrderRequest) {
      await this.getAdditionalColumnsData(key);
      this.flagOrderRequest = true;
    }
  }

  get newTableHeaders() {
    return this.tableColumnsInput.filter(
      (column: TableHeader) => column.active === true
    );
  }

  sortTheHeadersAndUpdateTheKey(evt: { oldIndex: number; newIndex: number }) {
    const headersTmp: TableHeader[] = this.newTableHeaders;
    const deactiveColumns = this.tableColumnsInput.filter(
      (column: TableHeader) => column.active === false
    );
    const oldIndex = evt.oldIndex;
    const newIndex = evt.newIndex;

    headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);

    this.tableColumnsInput.splice(0);
    headersTmp.forEach((element: TableHeader) => {
      this.tableColumnsInput.push(element);
    });
    deactiveColumns.forEach((element: TableHeader) => {
      this.tableColumnsInput.push(element);
    });
    this.increasingKeyCounter();
  }

  @Watch("dragableFilterMenu")
  reorderColumnByGroup() {
    const temp: TableHeader[] = [];
    this.tableColumnsGroup.forEach(groups => {
      this.tableColumnsInput.forEach((column: TableHeader) => {
        if (groups.key === column.type) temp.push(column);
      });
    });

    this.tableColumnsInput.splice(0);
    temp.forEach(item => this.tableColumnsInput.push(item));
  }

  toggleNewActionCard() {
    this.showNewActionCard = !this.showNewActionCard;
    this.showSelect = this.showNewActionCard;
    this.newActionCardColumnWidth = 4 - this.newActionCardColumnWidth;
    this.dashBoardColumnWidth = 12 - this.newActionCardColumnWidth;
    this.selectedTableData = [];
    this.notificationDialog = false;
    this.editMedicalOrderDialog = false;
    this.addTask = false;
  }

  increasingKeyCounter() {
    this.anIncreasingNumber++;
  }

  @Watch("selectedTableData")
  getActionUsers() {
    this.userIdArray = this.getTableFields();
  }

  getTableFields() {
    this.countSelectUsers = Object.keys(this.selectedTableData).length;
    this.itemsSelectedOnTable =
      this.selectedTableData.length == this.currentTableData.length
        ? this.totallItems
        : this.countSelectUsers;
    this.selectedUserRelated = [
      ...new Set(
        this.selectedTableData
          .filter(item => item.userRoles?.includes(USER_CONSTANTS.DEFAULT_ROLE))
          .map(item => item.userId)
      )
    ];
    return this.selectedTableData.map(tableField => {
      const action: ActionId = {
        id: tableField.userId,
        ref: tableField._key
      };

      if (this.currentMainFilter == COMPARISON_FILTERS.TASKS) {
        action.formTemplateId = tableField?.taskFormTemplateId ?? "";
      }
      return action;
    });
  }

  deleteDuplicates(listSelected: Array<ActionId | Dependency>) {
    const tempIdExists: KeyExists = {};
    const listFiltered = listSelected.filter((item: ActionId | Dependency) => {
      const exists = !tempIdExists[item.id!];
      tempIdExists[item.id!] = true;
      return exists;
    });
    return listFiltered;
  }

  isDuplicated(isDuplicated: boolean) {
    this.getActionUsers();
    if (!isDuplicated && this.currentMainFilter != COMPARISON_FILTERS.TASKS) {
      this.userIdArray = this.deleteDuplicates(this.userIdArray);
    }
  }

  createNotification() {
    if (this.userIdArray.length > 0) {
      this.notificationDialog = true;
    } else {
      Snackbar.popError(ACTION_MESSAGE.NO_USERS);
    }
  }

  createTask() {
    if (this.selectedUserRelated.length > 0) {
      this.addTask = true;
    } else {
      Snackbar.popError(ACTION_MESSAGE.NO_PATIENT);
    }
  }

  async editData() {
    if (this.userIdArray.length > 0) {
      this.getUserDependencies();
      this.editUserDataDialog = true;
    } else {
      Snackbar.popError(ACTION_MESSAGE.NO_USERS);
    }
  }

  editMedicalOrder() {
    if (this.userIdArray.length > 0) {
      this.editMedicalOrderDialog = true;
    } else {
      Snackbar.popError(ACTION_MESSAGE.NO_USERS);
    }
  }

  selectItem(item: object) {
    this.selectedItem = item;
  }

  unSelectItem() {
    this.selectedItem = {};
  }

  async modalEditMedicalOrder(orderId: string, cupsId: string) {
    const response = await this.medicalOrderService.getMedicalOrderById(
      orderId
    );

    if (response.code == Http.Found) {
      this.medicalOrder = response.data as MedicalOrderPreviewEventTimelineModel;
      this.cupsId = cupsId;
      this.showModalMedicalOrder = true;
    }
  }

  hideMedicalOrderModal() {
    this.showModalMedicalOrder = false;
  }

  async searchRoleByName(name: string) {
    await this.getRoles(name);
  }

  async searchDependencyByName(name: string) {
    await this.getDependencies(name);
  }

  async searchInfoGroupByName(name: string) {
    await this.getInfoGroups(name);
  }

  hideMedicalOrderDialog() {
    this.editMedicalOrderDialog = false;
  }

  hideAddTask() {
    this.addTask = false;
  }

  cancelNotification() {
    this.notificationDialog = false;
  }

  getEditableSchema() {
    if (this.orderTemplate.dashboardEditableFields) {
      for (const key of Object.keys(this.schema.allOf[0].properties)) {
        if (!this.orderTemplate.dashboardEditableFields.includes(key)) {
          delete this.schema.allOf[0].properties[key];
        }
      }
      delete this.schema.allOf[0].required;
    }
  }

  showDownloadDialog() {
    if (this.dashboardFilter.collection == DASBOARD_CURRENT_FILTER.ORDERS) {
      this.downloadAndUpdateDialog = true;
      return;
    }
    this.DOWNLOAD_MODAL_TEXT =
      this.showSelect &&
      this.selectedTableData.length == this.currentTableData.length
        ? DOWNLOAD_MODAL_TEXT_FULL
        : DOWNLOAD_MODAL_TEXT;
    this.dialogAccept = true;
  }

  handleModalAccept() {
    this.dialogAccept = false;
    this.downloadAndUpdateDialog = false;
    if (this.DOWNLOAD_MODAL_TEXT == DOWNLOAD_MODAL_TEXT_FULL) {
      this.DOWNLOAD_MODAL_TEXT = DOWNLOAD_FILE_GENERATED_TEXT;
      this.DOWNLOAD_MODAL_TITLE = DOWNLOAD_FILE_GENERATED_TITLE;
      this.dialogAccept = true;

      const headers = this.newTableHeaders.map(header => {
        return {
          value: header.value,
          text: header.text,
          type: header.type,
          active: header.active,
          localKey: header.localKey
        };
      });

      this.dashboardService.getExcelGeneratedFile(
        {
          ...this.dashboardFilter,
          services: FILTERED_DASHBOARD_TAGS.SEARCH,
          listOfSearch: [...this.listOfSearch],
          bigSearch: true
        },
        headers
      );
    } else if (this.DOWNLOAD_MODAL_TEXT == DOWNLOAD_MODAL_TEXT) {
      this.downloadExcelDocument();
    }
  }

  async handleAceptDownloadUpdateModal(update: boolean) {
    const allData =
      this.showSelect &&
      this.selectedTableData.length == this.currentTableData.length;
    if (update) {
      await this.updateOrders(allData);
    }
    this.DOWNLOAD_MODAL_TEXT = allData
      ? DOWNLOAD_MODAL_TEXT_FULL
      : DOWNLOAD_MODAL_TEXT;
    this.handleModalAccept();
  }
  handleModalCancel() {
    this.dialogAccept = false;
    this.downloadAndUpdateDialog = false;
  }

  downloadExcelDocument() {
    const data = this.newTableHeaders;
    const currentData =
      this.showSelect && this.selectedTableData.length > 0
        ? this.selectedTableData
        : this.currentTableData;
    const formatCurrentTableData = currentData.map(rowMap => {
      const row = lodash.cloneDeep(rowMap);
      const serviceSections = row.serviceSections || [];
      const userRoles = row.userRoles || [];
      const serviceGroups = row.serviceGroups || [];
      const assignedServices = row.assignedServices || [];
      const groupSections = row.groupSections || [];
      const sectionsFilled = row.sectionsFilled || {};
      const groupsFilled = row.groupsFilled || {};

      const taskDependencies = (row.taskDependencies as string[]) || [];
      const taskDateCompleted = (row.taskDateCompleted as number) || 0;
      const taskDateCreated = (row.taskDateCreated as number) || 0;
      const taskDateCanceled = (row.taskDateCanceled as number) || 0;

      row.taskDependencies = taskDependencies.join(", ").trim();
      row.taskDateElapsed = taskDateCreated
        ? this.getElapsedDate(
            taskDateCreated,
            taskDateCompleted,
            taskDateCanceled
          )
        : "";
      row.taskDateCompleted = taskDateCompleted
        ? this.getDate(taskDateCompleted)
        : "";
      row.taskDateCreated = taskDateCreated
        ? this.getDate(taskDateCreated)
        : "";
      row.taskDateCanceled = taskDateCanceled
        ? this.getDate(taskDateCanceled)
        : "";

      const groupSectionsString = groupSections
        .map(element => element.name)
        .join(", ");
      row.groupSections = groupSectionsString as any;

      const serviceSectionsString = serviceSections
        .map(element => element.name)
        .join(", ");
      row.serviceSections = serviceSectionsString as any;

      const userRolesString = userRoles.join(", ");
      row.userRoles = userRolesString as any;

      const serviceGroupsString = serviceGroups
        .map(element => element.name)
        .join(", ");
      row.serviceGroups = serviceGroupsString as any;

      const assignedServicesString = assignedServices.join(", ");
      row.assignedServices = assignedServicesString as any;

      let groupsFilledString = "";
      for (const value of Object.values(groupsFilled)) {
        groupsFilledString += `${value.name}: ${value.progress}%, `;
      }
      groupsFilledString = groupsFilledString.slice(0, -2);
      row.groupsFilled = groupsFilledString as any;

      let sectionsFilledString = "";
      for (const value of Object.values(sectionsFilled)) {
        sectionsFilledString += `${value.name}: ${value.progress}%, `;
      }
      sectionsFilledString = sectionsFilledString.slice(0, -2);
      row.sectionsFilled = sectionsFilledString as any;

      return row;
    });

    const buffer = Utils.createXLSXDocumentFromTableData(
      data,
      formatCurrentTableData
    );
    const name = Utils.getFileName(
      EXCEL_CONSTANTS.ADMIN_DASHBOARD,
      this.currentMainFilter
    );
    const blob = new Blob([buffer], { type: EXCEL_CONSTANTS.BUFFER_TYPE });
    Filesaver.saveAs(blob, name);
  }

  setList(name: string, list: List[]) {
    this.listObj = { name, list };
  }

  async handleSearchBarInfo(
    data: { type: string; key: string },
    parameter: any
  ) {
    const getData: {
      [list: string]: { [x: string]: (parameter: any) => Promise<void> };
    } = {
      service: {
        [DATA_TYPE_CONSULT.SERVICE.SERVICE_TEMPLATE]: async () => {
          await this.getServiceTemplates(
            DATA_TYPE_CONSULT.SERVICE.SERVICE_TEMPLATE
          );
        },
        [DATA_TYPE_CONSULT.SERVICE.SERVICE_CATEGORY]: async (
          parameter: string
        ) => {
          await this.getListDataById(
            DATA_TYPE_CONSULT.SERVICE.SERVICE_CATEGORY,
            parameter
          );
        },
        [DATA_TYPE_CONSULT.SERVICE.SERVICES_CUPS]: async () => {
          await this.getCups(DATA_TYPE_CONSULT.SERVICE.SERVICES_CUPS);
        }
      },
      form: {
        [DATA_TYPE_CONSULT.FORM.FORM_TEMPLATE]: async () => {
          await this.getFormTemplates(DATA_TYPE_CONSULT.FORM.FORM_TEMPLATE);
        },
        [DATA_TYPE_CONSULT.FORM.FORM_TEMPLATESCHEMA]: async (
          parameter: string[]
        ) => {
          await this.getFormTemplateSchema(parameter);
        }
      },
      user: {
        [DATA_TYPE_CONSULT.USER.DEPENDENCY]: async () => {
          await this.getAllDependencies(DATA_TYPE_CONSULT.USER.DEPENDENCY);
        },
        [DATA_TYPE_CONSULT.USER.ROLE]: async () => {
          await this.getRoleList(DATA_TYPE_CONSULT.USER.ROLE);
        },
        [DATA_TYPE_CONSULT.USER.USER_TEMPLATE]: async () => {
          await this.getUserTemplates(DATA_TYPE_CONSULT.USER.USER_TEMPLATE);
        },
        [DATA_TYPE_CONSULT.USER.USER_SCHEMA]: async (parameter: string[]) => {
          await this.getUserTemplateSchema(parameter);
        }
      },
      medicalOrder: {
        [DATA_TYPE_CONSULT.MEDICALORDER.ORDER_CUPS]: async () => {
          await this.getCups(DATA_TYPE_CONSULT.MEDICALORDER.ORDER_CUPS);
        },
        [DATA_TYPE_CONSULT.MEDICALORDER.ORDER_STATE]: async (
          parameter: string
        ) => {
          await this.getListDataById(
            DATA_TYPE_CONSULT.MEDICALORDER.ORDER_STATE,
            parameter
          );
        },
        [DATA_TYPE_CONSULT.MEDICALORDER.ORDER_SERVICE]: async () => {
          await this.getServiceTemplates(
            DATA_TYPE_CONSULT.MEDICALORDER.ORDER_SERVICE
          );
        },
        [DATA_TYPE_CONSULT.MEDICALORDER.ORDER_CODE]: async (
          parameter: string
        ) => {
          await this.getListDataById(
            DATA_TYPE_CONSULT.MEDICALORDER.ORDER_CODE,
            parameter
          );
        },
        [DATA_TYPE_CONSULT.MEDICALORDER.ORDER_TEMPLATE_SCHEMA]: async () => {
          await this.getMedicalOrderTemplate();
        }
      },
      session: {
        [DATA_TYPE_CONSULT.SESSION.SESSION_TEMPLATES]: async () => {
          await this.getAllSessionTemplates(
            DATA_TYPE_CONSULT.SESSION.SESSION_TEMPLATES
          );
        }
      },
      task: {
        [DATA_TYPE_CONSULT.FORM.FORM_TEMPLATE]: async () => {
          await this.getFormTemplates(DATA_TYPE_CONSULT.FORM.FORM_TEMPLATE);
        },
        [DATA_TYPE_CONSULT.USER.DEPENDENCY]: async () => {
          await this.getAllDependencies(DATA_TYPE_CONSULT.USER.DEPENDENCY);
        }
      }
    };
    const typeGetData = getData[data.type];
    const typeData =
      typeGetData !== undefined ? typeGetData[data.key] : undefined;

    if (typeData !== undefined) {
      await typeData(parameter);
    }
  }

  async getServiceTemplates(nameKey: string) {
    try {
      const response = await this.serviceTemplateService.getAllActiveServiceTemplate(
        STATE.ACTIVE
      );

      if (response.code === Http.Found && response.data) {
        const serviceTemplates = response.data;
        const serviceTemplatesList: List[] = [];
        serviceTemplates.forEach(({ id, internalName, groups }) => {
          serviceTemplatesList.push({
            key: id as string,
            name: internalName
          });
          if (groups) {
            for (const group of groups) {
              this.listOfServiceLevels.push({
                templateId: id as string,
                key: group.key as string,
                name: group.name
              });
            }
          }
        });
        await this.setList(nameKey, serviceTemplatesList);
        await this.getServiceLevels(DATA_TYPE_CONSULT.SERVICE.SERVICE_LEVEL);
        return serviceTemplatesList;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getServiceLevels(nameKey: string) {
    let serviceLevels: List[] = this.listOfServiceLevels;
    if (
      this.dashboardFilter.service?.serviceTemplate &&
      this.dashboardFilter.service?.serviceTemplate?.length > 0
    ) {
      serviceLevels = this.listOfServiceLevels.filter(e =>
        this.dashboardFilter.service?.serviceTemplate?.includes(e.templateId)
      );
    }
    await this.setList(
      nameKey,
      serviceLevels.map(e => {
        return {
          key: e.key,
          name: e.name
        };
      })
    );
  }

  async getListDataById(nameKey: string, id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(a =>
          listDataList.push({ key: a.title, name: a.title })
        );
        this.setList(nameKey, listDataList);
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getCups(nameKey: string) {
    try {
      const responseData = await this.cupsPriceLevelService.getAllActiveCupsPriceLevel();
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const serviceCups = responseData.data;
        const serviceCupsList: List[] = [];
        serviceCups.forEach(cup => {
          serviceCupsList.push({
            key: cup.id,
            name: `${cup.cups} - ${cup.externalName}`
          });
        });
        this.setList(nameKey, serviceCupsList);
        return serviceCupsList;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getFormTemplates(nameKey: string) {
    try {
      const response = await this.formTemplateService.getAllActiveFormTemplates();

      if (response.code === Http.Found && response.data) {
        const formTemplates = response.data;
        const formTemplatesList: List[] = [];
        formTemplates.forEach(({ _key, name }) => {
          formTemplatesList.push({
            key: _key as string,
            name
          });
        });
        this.setList(nameKey, formTemplatesList);
        return formTemplatesList;
      } else {
        Snackbar.popInfo(response.message);
        return [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getRoleList(nameKey: string) {
    try {
      const response = await this.rolesService.getAllActiveRoles();

      if (response.code === Http.Found && response.data) {
        const rolesUser = response.data;
        const rolesUserList: List[] = [];
        rolesUser.forEach(({ id, name }) => {
          rolesUserList.push({ key: id, name });
        });
        this.setList(nameKey, rolesUserList);
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET);
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  getUserDependencies() {
    const userDependencies = this.selectedTableData.map(
      users => users.userDependencies || []
    );
    let userDependenciesList: Dependency[] = [];
    userDependencies.forEach((userDependency: Dependency[]) => {
      userDependenciesList = userDependenciesList.concat(userDependency);
    });
    this.dependenciesToRemoveList = this.deleteDuplicates(
      userDependenciesList
    ) as Dependency[];
  }

  async getUserTemplates(nameKey: string) {
    try {
      const response = await this.userTemplateService.getAllActiveUserTemplates();
      if (response.code === Http.Found && response.data) {
        const formTemplatesUser = response.data;
        const formTemplatesUserList: List[] = [];
        formTemplatesUser.forEach(({ _key, name }) => {
          formTemplatesUserList.push({ key: _key, name });
        });
        this.setList(nameKey, formTemplatesUserList);
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUserTemplateSchema(id: string[]) {
    try {
      this.schemaTempUser = [];
      const consul: Promise<void>[] = [];

      id.forEach(item => {
        consul.push(this.getUserTempSchemaById(item));
      });

      await Promise.all(consul);

      this.fullSchema = this.schemaTempUser;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUserTempSchemaById(id: string) {
    try {
      const responseData = await this.userTemplateService.getUserTempSchemaById(
        id
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        responseData.data.schema.allOf.forEach(item => {
          this.schemaTempUser.push(item);
        });
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getMedicalOrderTemplate() {
    try {
      const responseData = await this.orderService.getOrderTempSchema();
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const medicalOrderFields = responseData.data.allOf[0].properties;
        const filteredFields = Object.keys(medicalOrderFields)
          .filter(
            f =>
              medicalOrderFields[f].typeField === "lista" &&
              medicalOrderFields[f]["x-display"] !== "checkbox"
          )
          .map(r => ({
            id: r,
            check: true,
            value: "",
            name: medicalOrderFields[r].title,
            list: (medicalOrderFields[r].oneOf ?? []).map(d => ({
              title: d.title,
              value: d.const
            }))
          }));
        this.items = filteredFields as TreeChildren[];
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ORDER_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async getAllDependencies(nameKey: string) {
    try {
      const response = await this.dependenciesService.findAll();
      if (response.code === Http.Found && response.data) {
        const dependencies = response.data;
        const dependenciesList: List[] = [];
        dependencies.forEach(({ id, data }) => {
          dependenciesList.push({ key: id, name: data.name });
        });
        this.setList(nameKey, dependenciesList);
        return dependenciesList;
      }
      Snackbar.popInfo(LACK_OF_OPTIONS);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        Snackbar.popError(
          DEPENDENCIES_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        );
      } else {
        Snackbar.popError(DEPENDENCIES_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  async getFormTemplateSchema(id: string[]) {
    try {
      this.schemaTempForm = [];
      const consul: Promise<void>[] = [];

      id.forEach(item => {
        consul.push(this.getFormTemplateSchemaById(item));
      });

      await Promise.all(consul);

      this.fullSchema = this.schemaTempForm;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getFormTemplateSchemaById(id: string) {
    try {
      const responseData = await this.formTemplateService.getFormTemplateSchemaById(
        id
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        responseData.data.fields.forEach(field => {
          this.schemaTempForm.push((field as any) as Field);
        });
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getAllSessionTemplates(nameKey: string) {
    try {
      const response = await this.sessionTemplateService.getAllActiveSessionTemplates();
      if (response.code === Http.Found && response.data) {
        const sessionTemplate = response.data;
        const sessionTemplateList: List[] = [];
        sessionTemplate.forEach(session => {
          sessionTemplateList.push({
            key: session.id as string,
            name: session.name
          });
        });
        this.setList(nameKey, sessionTemplateList);
        return sessionTemplateList;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SESSION_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  createOrder() {
    this.userIdForOrderModal = "";
    if (this.selectedTableData.length == 1) {
      if (
        this.selectedTableData[0].userRoles &&
        this.selectedTableData[0].userRoles.find(item => item == PATIENT) &&
        this.selectedTableData[0].userState &&
        this.selectedTableData[0].userState == ACTIVE
      ) {
        this.userIdForOrderModal = this.selectedTableData[0].userDocument.toString();
        this.orderDialog = true;
      } else {
        this.alertNoPatientRol();
      }
    } else if (this.selectedTableData.length > 1) {
      Snackbar.popError(ACTION_MESSAGE.TOO_MANY_USERS);
    } else {
      Snackbar.popError(ACTION_MESSAGE.NO_USERS);
    }
  }
  alertNoPatientRol() {
    Snackbar.popError(ACTION_MESSAGE.NO_PATIENT_ROL);
    this.closeOrderModal();
  }
  closeOrderModal() {
    this.orderDialog = false;
  }
  fireMasiveOrderModal() {
    this.masiveOrderModal = true;
  }
  closeMasiveOrderModal() {
    this.masiveOrderModal = false;
  }

  getDate(date: number) {
    return moment(date).format(DATE_FORMAT);
  }

  getElapsedDate(
    created: number,
    completed?: number,
    canceled?: number
  ): number {
    const dateReference = completed
      ? completed
      : canceled
      ? canceled
      : Date.now();

    return Math.trunc((dateReference - created) / DAY_IN_MS);
  }

  handleTaskActions(action: string) {
    if (this.userIdArray.length > 0) {
      this.actionTask = action;
      this.opentaskActionsModal = true;
    } else {
      Snackbar.popError(ACTION_TASK_CONSTANTS.NO_ITEMS_SELECTED);
    }
  }

  changeState() {
    console.log("cambiar el estado a ", this.currentMainFilter);
    if (this.selectedTableData.length == 0) {
      Snackbar.popWarning("Debe seleleccionar al menos un servicio");
      return;
    }
    this.openChangeStateModal = true;
  }
  closeTaskActionsModal(refreshDashboard: boolean) {
    this.actionTask = "";
    this.opentaskActionsModal = false;
    this.editUserDataDialog = false;
    this.userDataSuccess = [];
    this.userDataErrors = [];
    if (refreshDashboard) {
      this.searchWithFilter(this.dashboardFilter);
    }
  }
  orderRuleAccess(tracking: string) {
    if (tracking.includes(this.GENERATED_BY_RULE_ORDER)) {
      const ruleName = tracking
        .slice(
          tracking.indexOf(ORDER_GEN_UTILS.SEPATORS[0]) + 1,
          tracking.indexOf(ORDER_GEN_UTILS.SEPATORS[1])
        )
        .trim();
      store.commit(STORE_CONSTANTS.DASHBOARD_SEARCH_NAME, ruleName);
      this.$router.push(ORDER_GEN_UTILS.RULES_ROUTE);
    }
  }

  closeReportTask() {
    this.reportTask = [];
    this.masiveTaskResponse = false;
  }

  async updateOrders(alldata?: boolean) {
    if (alldata) {
      this.dashboardService.updateOrdersStatus(this.orderStateToUpdate, {
        bigSearch: true,
        ...this.dashboardFilter
      });
      return;
    }
    const data =
      this.showSelect && this.selectedTableData.length > 0
        ? this.selectedTableData
        : this.currentTableData;
    const ids: string[] = data.map(item => item._key);
    await this.dashboardService.updateOrdersStatus(
      this.orderStateToUpdate,
      undefined,
      ids
    );
  }

  validateTableColumnsGroupChecked() {
    for (const [index, group] of this.tableColumnsGroup.entries()) {
      for (const item of this.tableColumnsInput.filter(
        e => e.type == group.key
      )) {
        if (!item.active) {
          this.tableColumnsGroup[index].allActive = false;
          break;
        }
        this.tableColumnsGroup[index].allActive = true;
      }
    }
  }

  async setFilterArray(collection: string) {
    try {
      if (this.listNames[collection]) {
        const response = await this.listService.getListOptionsByName(
          this.listNames[collection].name as string
        );
        if (response.code == Http.Found) {
          const collectionFilterIndex = FILTERS_LIST.findIndex(
            item => item.mainFilterKey === collection.slice(0, -1)
          );
          const subIndex = this.filterArray[
            collectionFilterIndex
          ].secondaryFilters.findIndex(
            element => element.key === this.listNames[collection].stateName
          );
          this.filterArray[collectionFilterIndex].secondaryFilters[
            subIndex
          ].options = response.data?.map(item => {
            const stateFound = (this.listNames[collection].states as Array<{
              key: string;
              name: string;
            }>).find(element => element.key == item.id);
            if (!stateFound) {
              (this.listNames[collection].states as Array<{
                key: string;
                name: string;
              }>).push({
                key: item.id as string,
                name: item.title
              });
            }
            return {
              key: item.id,
              name: item.title
            };
          });
          return;
        }
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  getStatesByCollection(filter: DashboardFilter) {
    if (!this.listNames[filter.collection]) {
      return;
    }
    if (
      !(filter[filter.collection.slice(0, -1) as keyof DashboardFilter] as any)[
        this.listNames[filter.collection].stateName as string
      ]
    ) {
      return;
    }
    const state = (filter[
      filter.collection.slice(0, -1) as keyof DashboardFilter
    ] as any)[this.listNames[filter.collection].stateName as string][0];

    if (!state) {
      return;
    }
    const stateFound: { key: string; name: string } | undefined = (this
      .listNames[filter.collection].states as []).find(
      item => (item as { key: string; name: string }).name == state
    );

    if (stateFound) {
      (filter[filter.collection.slice(0, -1) as keyof DashboardFilter] as any)![
        this.listNames[filter.collection].stateName as string
      ][0] = (stateFound as { key: string; name: string }).key;
    }
  }

  async changeStateAction(state: string, states: DynamicSelectData[]) {
    try {
      this.openChangeStateModal = false;
      this.loadingTable = true;
      if (this.selectedTableData.length == this.currentTableData.length) {
        const dashboardFilterClone = lodash.cloneDeep(this.dashboardFilter);
        if (!dashboardFilterClone.allSelectFilter?.state) {
          dashboardFilterClone!.service!.state = states
            .filter(item => item.id != state)
            .map(item => item.id);
        }
        const updateServicesResponse = await this.dashboardService.updateServiceStatus(
          state,
          {
            bigSearch: true,
            ...dashboardFilterClone
          }
        );

        if (updateServicesResponse.code == Http.Ok) {
          Snackbar.popSuccess(updateServicesResponse.message);
          await this.getDashboardInfoData({
            ...this.dashboardFilter,
            services: FILTERED_DASHBOARD_TAGS.SEARCH,
            listOfSearch: [...this.listOfSearch]
          });
          return;
        }
        throw Error;
      }
      const data =
        this.showSelect && this.selectedTableData.length > 0
          ? this.selectedTableData
          : this.currentTableData;
      const ids: string[] = data.map(item => item._key);
      await this.dashboardService.updateServiceStatus(state, undefined, ids);
      await this.getDashboardInfoData({
        ...this.dashboardFilter,
        services: FILTERED_DASHBOARD_TAGS.SEARCH,
        listOfSearch: [...this.listOfSearch]
      });
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    this.loadingTable = false;
  }

  cancelChangeServiceState() {
    this.openChangeStateModal = false;
  }
}
